import { Box, Chip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { useParams } from "react-router-dom";
import { useTheme } from "../../../../../context/themeContext";
import axios from "axios";
import { node_server } from "../../../../../constants";

const CommunityStatus = () => {
  const { theme } = useTheme();
  const [status, setStatus] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const fetchStatus = async () => {
      const { data, error } = await axios.get(
        `${node_server}/api/user/${id}/status`,
        {
          withCredentials: true,
        },
      );

      if (error) console.log(error, "from error");
      setStatus(data.filter((item) => item.status !== "In Complete"));
    };

    fetchStatus();
  }, [id]);

  return (
    <Box
      className={styles.community}
      sx={{ bgcolor: theme.palette.lightgrey.lightgrey00, width: "100%" }}
    >
      <Typography
        variant="body"
        className={styles.heading}
        sx={{ color: theme.palette.darkgrey.darkgrey600 }}
      >
        Tags
      </Typography>
      <Box className={styles.tags}>
        {status.map(({ status }, index) => (
          <Chip
            key={index}
            label={status}
            sx={{
              bgcolor:
                status === "Admin"
                  ? theme.palette.primary.main
                  : status === "Verified"
                  ? theme.palette.success.dark
                  : "intial",
              color:
                status === "Admin" || status === "Verified"
                  ? "#FFF"
                  : theme.palette.darkgrey.darkgrey500,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CommunityStatus;
